export const RGB_HOME_PAGE = () => "/estoque/rgb";
export const RGB_IMPORT_PAGE = () => "/estoque/rgb/importar";
export const RGB_REPORT_PAGE = () => "/estoque/rgb/relatorio";
export const RGB_PACKAGINGS_PAGE = () => "/estoque/rgb/vasilhames";
